document.addEventListener("DOMContentLoaded", () => {
    const cards = document.querySelectorAll('.card-step');

    const setUniformHeight = () => {
        let maxHeight = 0;

        cards.forEach(card => {
            card.style.height = 'auto';
        });

        cards.forEach(card => {
            const height = card.scrollHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });

        cards.forEach(card => {
            card.style.height = `${maxHeight}px`;
        });
    };

    window.addEventListener('load', setUniformHeight);
    window.addEventListener('resize', setUniformHeight);
    window.addEventListener('scroll', setUniformHeight);

    setTimeout(setUniformHeight, 100); // Safety delay
});
